import { useAppDispatch, useAppSelector } from '@/hooks/use.redux';
import { useCallback } from 'react';
import { actionSetRemoteActivityStatus } from '@/redux';
import { ActivityStatusEnum } from '@matap/shared';

export function useActivityStatus() {
  const dispatch = useAppDispatch();
  const activityStatusExpirationTimerId = useAppSelector((reducer) => reducer.chatReducer.activityStatusExpirationTimerId);
  const remoteActivityStatus = useAppSelector((reducer) => reducer.chatReducer.remoteActivityStatus);

  const setRemoteActivityStatus = useCallback(
    (status: ActivityStatusEnum) => {
      clearTimeout(activityStatusExpirationTimerId);
      if (status === ActivityStatusEnum.IDLE) {
        dispatch(
          actionSetRemoteActivityStatus({
            status: ActivityStatusEnum.IDLE,
          }),
        );
      } else {
        dispatch(
          actionSetRemoteActivityStatus({
            status,
            timer: setTimeout(
              () =>
                dispatch(
                  actionSetRemoteActivityStatus({
                    status: ActivityStatusEnum.IDLE,
                  }),
                ),
              3000,
            ),
          }),
        );
      }
    },
    [dispatch, activityStatusExpirationTimerId],
  );
  return {
    activityStatusExpirationTimerId,
    remoteActivityStatus,
    setRemoteActivityStatus,
  };
}
